var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { Alert, Card, CardBody, CardFooter, FormGroup, Label, Input, Form, CardHeader } from 'reactstrap';
import _ from 'lodash';
import Page from '../Page';
import { ApplicationContext } from '../../../ApplicationContext';
import Routes from '../../../routes/RoutesConfig';
import RouteUtils from '../../../routes/routeUtils';
import ProviderData from '../../../data/ProviderData';
import FeedDataType from '../../../data/FeedDataType';
import CreateFeedCommand from '../../../commands/feeds/CreateFeedCommand';
import UpdateFeedCommand from '../../../commands/feeds/UpdateFeedCommand';
import getOrganisationFeeds from '../../../requests/organisation/getOrganisationFeeds';
import deleteFeed from '../../../requests/feed/deleteFeed';
import Signals from '../../../signals/Signals';
import FormField from '../../components/ui/FormField/FormField';
import { FormErrorContext } from '../../../FormErrorContext';
import { createErrorResponse, notifyUncaughtErrors } from '../../../utils/errorUtils';
import FeedModel from '../../../models/FeedModel';
import GetFeedCommand from '../../../commands/feeds/GetFeedCommand';
import withRouter from "../../components/ui/MainNavigation/withRouter";
/**
 *
 */
var Feed = /** @class */ (function (_super) {
    __extends(Feed, _super);
    /**
     *
     */
    function Feed(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            errors: [],
            submitting: false,
            feed: new FeedModel(),
        };
        _this.onInputChange = _this.onInputChange.bind(_this);
        _this.onProviderChange = _this.onProviderChange.bind(_this);
        _this.onDataTypeChange = _this.onDataTypeChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.onSuccess = _this.onSuccess.bind(_this);
        _this.onError = _this.onError.bind(_this);
        return _this;
    }
    /**
     *
     */
    Feed.prototype.componentDidMount = function () {
        this.initialize();
    };
    /**
     *
     * @param nextProps
     * @param nextContext
     */
    Feed.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        this.initialize();
    };
    /**
     *
     */
    Feed.prototype.initialize = function () {
        var _this = this;
        var params = RouteUtils.getVariables();
        if (params.id && params.id !== 'add') {
            var id = params.id;
            this.setState({
                isEditing: !!id
            });
            var session = this.context.session;
            var user = session.user;
            var command = new GetFeedCommand();
            command.execute(id, user.organisation.id).then(function (response) {
                _this.setState({ feed: new FeedModel(response) });
                _this.setState({
                    providerTypes: _this._getProviderTypes()
                });
            }).catch(this.onError);
        }
    };
    /**
     *
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    Feed.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        notifyUncaughtErrors(this.state, this.props.intl, ['url', 'credentials']);
    };
    /**
     *
     * @returns {*}
     */
    Feed.prototype.render = function () {
        var intl = this.props.intl;
        var session = this.context.session;
        if (!session.isLoggedIn) {
            return null;
        }
        var _a = this.state, isEditing = _a.isEditing, feed = _a.feed;
        var providerName = feed.providerName, dataType = feed.dataType, username = feed.username;
        var providerUrl = this._getSelectedProviderUrl();
        var providers = this._getProviderNames();
        var providerTypes = this._getProviderTypes();
        var isVolvoTdsV2 = dataType == FeedDataType.TdsV2VolvoCareTrack.name;
        var isStaadTdsV2 = dataType == FeedDataType.TdsV2Staad.name;
        var isCatEntraId = dataType == FeedDataType.TdsV2CatEntraId.name;
        var hideUsername = isVolvoTdsV2 || isStaadTdsV2;
        var usernameLabelId = isCatEntraId ? 'page.feed.field.clientid' : 'page.feed.field.username';
        var passwordLabelId = isCatEntraId ? 'page.feed.field.clientsecret' : 'page.feed.field.password';
        return (React.createElement(Page, { pageName: "feed" },
            React.createElement("div", { className: "h-100 pb-4" },
                React.createElement(Card, { className: "mh-100", style: { width: "95%", borderRadius: "0px 20px 20px 0px", maxHeight: "100%" } },
                    React.createElement(CardHeader, null,
                        React.createElement("h1", { className: "card-header-title" },
                            React.createElement(FormattedMessage, { id: isEditing ? 'page.feed.title.edit' : 'page.feed.title.add' }))),
                    React.createElement(CardBody, { className: "pt-0 mr-4 pr-0 overflow-auto" },
                        this._getAlert(),
                        this._getCatDeprecationAlert(),
                        this.state.hasConflictingCatFeed ?
                            React.createElement(Alert, { color: "info" },
                                React.createElement(FormattedMessage, { id: "page.feed.conflict.cat" }))
                            : null,
                        React.createElement(FormErrorContext.Provider, { value: { errors: this.state.errors } },
                            React.createElement(Form, { onChange: this.onInputChange, onSubmit: this.onSubmit, autoComplete: isEditing ? 'no' : null, id: "feedForm" },
                                React.createElement(FormGroup, { className: "pb-4" },
                                    React.createElement("label", null,
                                        React.createElement(FormattedMessage, { id: "page.feed.field.provider" })),
                                    React.createElement(FormField, null,
                                        React.createElement(Select, { className: "form-control select2 col-xs-12 col-md-6", classNamePrefix: "select2", name: "providerName", id: "providerName", isDisabled: isEditing, isRequired: true, value: providers.find(function (object) { return object.value === providerName; }), options: providers, onChange: this.onProviderChange, menuPortalTarget: document.body, menuPosition: "fixed", styles: { menuPortal: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); } }, placeholder: intl.formatMessage({ id: 'page.feed.field.provider.placeholder' }) }),
                                        React.createElement(Select, { className: "form-control select2 mt-2 mt-md-0 ml-md-2 col-xs-12 col-md-4", classNamePrefix: "select2", name: "dataType", id: "dataType", isDisabled: isEditing, isRequired: true, value: providerTypes.find(function (object) { return object.name === dataType; }), options: providerTypes, onChange: this.onDataTypeChange, menuPortalTarget: document.body, menuPosition: "fixed", styles: { menuPortal: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); } }, placeholder: intl.formatMessage({ id: 'page.feed.field.format.placeholder' }) }))),
                                providerUrl ?
                                    React.createElement(FormGroup, null,
                                        React.createElement("label", null,
                                            React.createElement(FormattedMessage, { id: "page.feed.field.url" })),
                                        React.createElement(FormField, null,
                                            React.createElement("a", { href: providerUrl }, providerUrl))) : null,
                                !hideUsername ?
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, { for: "username" },
                                            React.createElement(FormattedMessage, { id: usernameLabelId })),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { type: "text", name: "username", id: "username", autoComplete: "off", value: username })))
                                    : null,
                                !isVolvoTdsV2 ?
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, { for: "password" },
                                            React.createElement(FormattedMessage, { id: passwordLabelId })),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { type: "password", name: "password", id: "password", autoComplete: "new-password", required: true })))
                                    : null,
                                isVolvoTdsV2 ?
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, { for: "idpClientId" }, "IDP ID"),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { type: "text", name: "idpClientId", id: "idpClientId", autoComplete: "off", required: true })))
                                    : null,
                                isVolvoTdsV2 ?
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, { for: "idpClientSecret" }, "IDP Secret"),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { type: "password", name: "idpClientSecret", id: "idpClientSecret", autoComplete: "off", required: true })))
                                    : null,
                                isVolvoTdsV2 ?
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, { for: "xGwClientId" }, "x-gw-client-id"),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { type: "text", name: "xGwClientId", id: "xGwClientId", autoComplete: "off", required: true })))
                                    : null,
                                isVolvoTdsV2 ?
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, { for: "xGwClientSecret" }, "x-gw-client-secret"),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { type: "password", name: "xGwClientSecret", id: "xGwClientSecret", autoComplete: "off", required: true })))
                                    : null,
                                isVolvoTdsV2 ?
                                    React.createElement(FormGroup, null,
                                        React.createElement(Label, { for: "idpScope" }, "Scope"),
                                        React.createElement(FormField, null,
                                            React.createElement(Input, { type: "text", name: "idpScope", id: "idpScope", autoComplete: "off", required: true })))
                                    : null))),
                    React.createElement(CardFooter, null,
                        React.createElement("div", { className: "d-flex justify-content-end" },
                            isEditing ?
                                React.createElement(Link, { to: Routes.FEEDS.getPath() },
                                    React.createElement("button", { className: "btn btn-outline-primary mr-3", type: "button" },
                                        React.createElement(FormattedMessage, { id: "page.feed.cancel" }))) : null,
                            React.createElement("button", { className: "btn btn-primary", form: "feedForm", type: "submit", disabled: this.state.submitting },
                                React.createElement(FormattedMessage, { id: this.state.hasConflictingCatFeed ? 'page.feed.replace' : 'page.feed.save' }))))))));
    };
    /**
     *
     * @param option
     */
    Feed.prototype.onProviderChange = function (option) {
        var feed = this.state.feed;
        feed.providerName = option.value;
        var providerTypes = this._getProviderTypes();
        this.onDataTypeChange(providerTypes.find(function (o) { return o; }));
        this.setState({
            providerTypes: providerTypes
        });
    };
    /**
     *
     * @param option
     */
    Feed.prototype.onDataTypeChange = function (option) {
        var feed = this.state.feed;
        feed.dataType = option.name;
        feed.url = this._getSelectedProviderUrl();
        var selectedProvider = feed.getProvider();
        feed.refreshInSeconds = selectedProvider ? selectedProvider.refreshInSeconds : 3600;
    };
    /**
     *
     * @param event
     */
    Feed.prototype.onInputChange = function (event) {
        var feed = this.state.feed;
        switch (feed.dataType) {
            case FeedDataType.TdsV2VolvoCareTrack.name:
                switch (event.target.name) {
                    case "password":
                        this.setState({ password: event.target.value });
                        break;
                    case "idpClientId":
                        this.setState({ idpClientId: event.target.value });
                        break;
                    case "idpClientSecret":
                        this.setState({ idpClientSecret: event.target.value });
                        break;
                    case "idpScope":
                        this.setState({ idpScope: event.target.value });
                        break;
                    case "xGwClientId":
                        this.setState({ xGwClientId: event.target.value });
                        break;
                    case "xGwClientSecret":
                        this.setState({ xGwClientSecret: event.target.value });
                        break;
                    default:
                        feed[event.target.name] = event.target.value;
                }
                break;
            default:
                switch (event.target.name) {
                    default:
                        feed[event.target.name] = event.target.value;
                }
        }
    };
    /**
     *
     * @param event
     */
    Feed.prototype.onSubmit = function (event) {
        event.preventDefault();
        var session = this.context.session;
        var feed = this.state.feed;
        var intl = this.props.intl;
        // In case of Volvo TDSV2 feed make JSON string for password
        if (feed.dataType == FeedDataType.TdsV2VolvoCareTrack.name) {
            feed.password = JSON.stringify({
                idpClientId: this.state.idpClientId,
                idpClientSecret: this.state.idpClientSecret,
                scope: this.state.idpScope,
                xGwClientId: this.state.xGwClientId,
                xGwClientSecret: this.state.xGwClientSecret
            });
            feed.username = FeedDataType.TdsV2VolvoCareTrack.name; //not used but required for volvo tds v2
        }
        else if (feed.dataType == FeedDataType.TdsV2Staad.name) {
            feed.username = FeedDataType.TdsV2Staad.name; //required but not used for staad tds v2
        }
        var oauthUrl = this._getSelectedOauthUrl();
        if (oauthUrl) {
            feed.url = this._getSelectedProviderUrl() + "**".concat(oauthUrl);
        }
        this.setState({ errors: null, submitting: true });
        if (this.state.hasConflictingCatFeed) {
            this._replaceConflictingFeed();
        }
        else if (!feed.id) {
            var command = new CreateFeedCommand();
            feed.isEnabled = true; // always enable feed
            command.execute(feed, session.user.organisation.id, intl)
                .then(this.onSuccess)
                .catch(this.onError);
        }
        else {
            var command = new UpdateFeedCommand();
            feed.isEnabled = true; // always enable feed
            command.execute(feed, session.user.organisation.id, intl)
                .then(this.onSuccess)
                .catch(this.onError);
        }
    };
    /**
     *
     * @param user
     */
    Feed.prototype.onSuccess = function (user) {
        this.setState({ submitting: false });
        this.props.router.navigate(Routes.FEEDS.getPath());
    };
    /**
     *
     * @param error
     */
    Feed.prototype.onError = function (error) {
        var _a, _b, _c;
        try {
            var errors = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.body) === null || _c === void 0 ? void 0 : _c.errors;
            var dataTypeErrors = errors === null || errors === void 0 ? void 0 : errors.dataType;
            if (dataTypeErrors === null || dataTypeErrors === void 0 ? void 0 : dataTypeErrors.includes('error.Invalid.error.ConflictingCatFeedExists')) {
                this.setState({ hasConflictingCatFeed: true, submitting: false });
                return;
            }
            // Map credential errors to the username field
            if (errors === null || errors === void 0 ? void 0 : errors.credentials) {
                errors.username = errors.credentials;
                delete errors.credentials;
            }
        }
        catch (_) {
            // fall through to default error handling
        }
        createErrorResponse(this, error);
    };
    Feed.prototype._replaceConflictingFeed = function () {
        var _this = this;
        var session = this.context.session;
        var feed = this.state.feed;
        var intl = this.props.intl;
        var user = session.user;
        var organisationId = user.organisation.id;
        getOrganisationFeeds(user.organisation, false)
            .then(function (feeds) {
            var oldCatFeed = feeds.find(function (f) { return f.providerName === 'CAT' && f.dataType !== feed.dataType; });
            if (!oldCatFeed) {
                Signals.ShowNotification.dispatch(intl.formatMessage({ id: 'page.feed.conflict.cat.notfound' }), 'danger');
                _this.setState({ submitting: false, hasConflictingCatFeed: false });
                return;
            }
            return deleteFeed(oldCatFeed.id, organisationId);
        })
            .then(function (result) {
            if (result === undefined)
                return;
            _this.setState({ hasConflictingCatFeed: false });
            var command = new CreateFeedCommand();
            feed.isEnabled = true;
            command.execute(feed, organisationId, intl)
                .then(_this.onSuccess)
                .catch(_this.onError);
        })
            .catch(function (error) {
            var _a;
            _this.setState({ submitting: false });
            Signals.ShowNotification.dispatch(intl.formatMessage({ id: 'page.feed.conflict.cat.error' }, { error: ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.message) || (error === null || error === void 0 ? void 0 : error.message) || 'Unknown error' }), 'danger');
        });
    };
    /**
     *
     * @return {*[]}
     * @private
     */
    Feed.prototype._getProviderNames = function () {
        return _.uniqWith(ProviderData.map(function (data) {
            var provider = data.provider;
            return { label: provider, value: provider };
        }), function (providerA, providerB) { return providerA.value === providerB.value; });
    };
    /**
     *
     * @return {*[]}
     * @private
     */
    Feed.prototype._getProviderTypes = function () {
        var _this = this;
        var feed = this.state.feed;
        if (!feed.providerName)
            return [];
        var dataTypes = Object.keys(FeedDataType);
        var intl = this.props.intl;
        var providerDataForProviderName = ProviderData.filter(function (provider) {
            return provider.provider == feed.providerName;
        });
        return dataTypes.map(function (key) {
            var dataType = FeedDataType[key];
            if (dataType.visible && providerDataForProviderName.find(function (provider) { return provider.feedDataType.name == dataType.name; })) {
                var isDisabled = dataType.disabled
                    || (dataType.name === FeedDataType.TdsV2Cat.name && _this._isCatV1Deprecated());
                return {
                    value: dataType.id,
                    name: dataType.name,
                    isDisabled: isDisabled,
                    isSelected: dataType.selected,
                    label: intl.formatMessage({ id: dataType.labelId })
                };
            }
            else {
                return null;
            }
        }).filter(function (option) {
            return option != null;
        });
    };
    /**
     *
     * @private
     */
    Feed.prototype._getAlert = function () {
        var intl = this.props.intl;
        var _a = this.state, isEditing = _a.isEditing, feed = _a.feed;
        if (!isEditing || !feed.hasUrgentStatus()) {
            return null;
        }
        return feed.status != null ?
            React.createElement(Alert, { color: feed.getStatusType() }, feed.getStatusMessage(intl)) : null;
    };
    Feed.prototype._getCatDeprecationAlert = function () {
        var feed = this.state.feed;
        if (feed.dataType !== FeedDataType.TdsV2Cat.name) {
            return null;
        }
        var isExpired = this._isCatV1Deprecated();
        var messageId = isExpired
            ? 'page.feed.cat.deprecated.expired'
            : 'page.feed.cat.deprecated.warning';
        return (React.createElement(Alert, { color: isExpired ? 'danger' : 'warning' },
            React.createElement(FormattedMessage, { id: messageId })));
    };
    /**
     *
     * @private
     */
    Feed.prototype._isCatV1Deprecated = function () {
        return new Date() >= new Date('2026-07-01');
    };
    Feed.prototype._getSelectedProviderUrl = function () {
        var feed = this.state.feed;
        var session = this.context.session;
        var user = session.user;
        var organisation = user.organisation;
        var selectedProvider = feed.getProvider();
        return selectedProvider ? selectedProvider.url.replace('{organisationId}', organisation.id) : null;
    };
    /**
     *
     * @private
     */
    Feed.prototype._getSelectedOauthUrl = function () {
        var feed = this.state.feed;
        var session = this.context.session;
        var user = session.user;
        var selectedProvider = feed.getProvider();
        return selectedProvider ? selectedProvider.oauth2url : null;
    };
    Feed = __decorate([
        observer
    ], Feed);
    return Feed;
}(React.Component));
Feed.contextType = ApplicationContext;
export default injectIntl(withRouter(Feed));
